'use strict';

define('NVForm',['backbone', 'deviceInfo'], function (Backbone, deviceInfo) {
  // Ensure this is on or IE will fail.
  Backbone.emulateHTTP = !!deviceInfo.ie;
  var $ = Backbone.$,
    _ = Backbone._;
  return Backbone.Model.extend({
    __name__: 'NVForm',
    urlRoot: function () {
      var options = this.get('options');
      var endpoint = options.formdefEndpoint || options.endpoint;
      // Replace actions.ngpvan.com with secure.ngpvan.com (or equivalent)
      return endpoint.replace(/(actions)(\.(ngpvan|everyaction)\.com)/, 'secure$2');
    },
    initialize: function (options) { // jshint ignore:line
      this.set('obfuscatedId', this.id, {silent: true});
      this.s3Failed = false;
      if (this.get('options').formUrl) {
        this.url = this.get('options').formUrl;

        // if the URL ends in a question mark or ampersand, remove it
        // it causes issues with the constructed URL for ASP.NET handling
        var endsInQuestionMarkOrAmp = this.url.match(/(.+)[?&]+$/);
        if(endsInQuestionMarkOrAmp && endsInQuestionMarkOrAmp.length) {
          this.url = endsInQuestionMarkOrAmp[1];
        }
      }
    },
    fetch: function (options) {
      options = options || {};
      if (this.get('options').formUrl) {
        options.xhrFields = { withCredentials: true };
      }
      if(this.get('options').query_string_case_preserved){
        options.data = $.param(this.get('options').query_string_case_preserved);
      }
      var deferred = $.Deferred(), refetch = _.bind(function () {
        this.s3Failed = true;
        this.urlRoot = this.get('options').endpoint;
        Backbone.Model.prototype.fetch.call(this, options).then(deferred.resolve, deferred.reject);
      }, this);
      Backbone.Model.prototype.fetch.call(this, options)
        .then(deferred.resolve, (this.s3Failed ? deferred.reject : refetch));
      return deferred.promise();
    }
  });
});

